import { ActionIcon, HoverCard, type MantineColor, ThemeIcon } from "@mantine/core";
import { IconFileCheck, IconFileIsr } from "@tabler/icons-react";
import type { ReactNode } from "react";

type FileSyncIndicatorProps = {
  warn: boolean;
  warnIcon?: ReactNode;
  okIcon?: ReactNode;
  onWarnAction?: () => void;
  warnText: ReactNode;
  okText?: ReactNode;
  warnColor?: MantineColor;
};

export function FileSyncIndicator({
  warn,
  warnIcon = <IconFileIsr />,
  okIcon = <IconFileCheck />,
  warnText,
  okText,
  warnColor = "zli-orange",
  onWarnAction,
}: FileSyncIndicatorProps) {
  const color = warn ? warnColor : "zli-green";
  const text = warn ? warnText : okText;
  const icon = warn ? warnIcon : okIcon;

  return (
    <HoverCard>
      <HoverCard.Target>
        {onWarnAction && warn ? (
          <ActionIcon onClick={onWarnAction} color={warnColor} variant="subtle">
            {warnIcon}
          </ActionIcon>
        ) : (
          <ThemeIcon color={color} variant="subtle">
            {icon}
          </ThemeIcon>
        )}
      </HoverCard.Target>
      <HoverCard.Dropdown>{text}</HoverCard.Dropdown>
    </HoverCard>
  );
}
